import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/reviews/ReviewCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/web/src/components/reviews/StarRating.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
